const messages = {
  en: {
    title: "Account settings",
    integrationStatus: "Integration status",
    connected: "Connected",
    disconnected: "Disconnected",
    disconnectIntegration: "Disconnect integration",
    reconnectIntegration: "Reconnect integration",
    subscriptionPlan: "Subscription plan",
    active: "Active",
    pending: "Pending",
    inactive: "Inactive",
    planMonthly: "Monthly plan: $9.99 per month",
    planYearly: "Annual plan: $99.00 per year",
    monthly: "Monthly",
    yearly: "Yearly",
    renewalDate: "Renewal date",
  },
  fr: {
    title: "Paramètres du compte",
    integrationStatus: "Statut de l'intégration",
    connected: "Connecté",
    disconnected: "Déconnecté",
    disconnectIntegration: "Déconnecter l'intégration",
    reconnectIntegration: "Reconnecter l'intégration",
    subscriptionPlan: "Plan d'abonnement",
    active: "Actif",
    pending: "En attente",
    inactive: "Inactif",
    planMonthly: "Plan mensuel : 9,99 $ par mois",
    planYearly: "Plan annuel : 99,00 $ par an",
    monthly: "Mensuel",
    yearly: "Annuel",
    renewalDate: "Date de renouvellement",
  },
};

export default messages;
